import axios from "axios";

export default axios.create({
 baseURL: "https://backend.repairadda.com/RepAda",
  // baseURL : "https://8ichqr3xap.ap-northeast-1.awsapprunner.com/RepAda",
 // baseURL: "https://repairadda.com:8443/neobetest/interactionhistory/9853258963",
 // saveQuestionnaire:"https://backend.repairadda.com/RepAda/saveOrUpdateCustomerServiceRequest.html",
  responseType: "json",
});
